import React, { ReactElement } from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { Outlet } from 'react-router-dom';

import { ModuleDeclaration } from '../ModuleDeclaration';

import SeoContainer from './SeoContainer/SeoContainer';


const SeoWrapper = (props: any): JSX.Element => {
  const element = withAuthenticationRequired(Outlet)(props);
  return element! as ReactElement;
};

const SeoRouteProperties: ModuleDeclaration = {
  routeProps: {
    path: '/seo',
    element: <SeoWrapper />,
    children: [
      { index: true, element: <SeoContainer /> }
    ],
  },
  name: 'SEO',
  isHidden: false,
  containerCss: 'mb-5 border-bottom',
  iconClassName: 'bi bi-search-heart',
};

export default SeoRouteProperties;
